import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';

import {environment} from '../../../environments/environment';
import {ActionContextService, REQUEST_ID_HEADER} from '../service/action-context.service';

/**
 * Adds the current action id as the X-Request-Id header to every call to our backend.
 * The backend propagates the value into its logging MDC (RequestIdRestInterceptor),
 * so BE logs of all calls belonging to one user action share one id with the FE logs.
 *
 * Must be registered before the other interceptors so they see the header
 * (ErrorInterceptor attaches it to failure logs).
 */
@Injectable()
export class RequestIdInterceptor implements HttpInterceptor {

    constructor(private actionContext: ActionContextService) {
    }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        // Only our own API — a custom header on third-party requests would break CORS.
        if (!request.url.startsWith(environment.apiUrl)) {
            return next.handle(request);
        }
        return next.handle(request.clone({
            setHeaders: {[REQUEST_ID_HEADER]: this.actionContext.currentActionId}
        }));
    }
}
